import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class EvisionSerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
